var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPasswordVisible(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons for Input",
    clipPath: "url(#clip0_2912_41648)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.73793 8.68704C1.64714 8.54328 1.60174 8.4714 1.57633 8.36053C1.55724 8.27725 1.55724 8.14592 1.57633 8.06264C1.60174 7.95178 1.64714 7.8799 1.73793 7.73614C2.4882 6.54815 4.72144 3.54492 8.12478 3.54492C11.5281 3.54492 13.7614 6.54815 14.5116 7.73614C14.6024 7.8799 14.6478 7.95178 14.6732 8.06264C14.6923 8.14592 14.6923 8.27725 14.6732 8.36053C14.6478 8.4714 14.6024 8.54328 14.5116 8.68704C13.7614 9.87503 11.5281 12.8783 8.12478 12.8783C4.72145 12.8783 2.4882 9.87503 1.73793 8.68704Z",
    stroke: "#6C737F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12478 10.2116C9.22935 10.2116 10.1248 9.31616 10.1248 8.21159C10.1248 7.10702 9.22935 6.21159 8.12478 6.21159C7.02021 6.21159 6.12478 7.10702 6.12478 8.21159C6.12478 9.31616 7.02021 10.2116 8.12478 10.2116Z",
    stroke: "#6C737F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2912_41648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.124512 0.210938)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordVisible);
export default __webpack_public_path__ + "static/media/PasswordVisible.5f1259d7457ca345f7557ff91c801050.svg";
export { ForwardRef as ReactComponent };